/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { SysquePdfLocationComponent } from './sysque-pdf-location.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule } from 'devextreme-angular';


@NgModule({
  declarations: [SysquePdfLocationComponent],
  imports: [
    CommonModule, 
    DxButtonModule
  ],
  exports: [SysquePdfLocationComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysquePdfLocationModule {}